import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import TitleBasic, {
  titleBasicColors,
  titleBasicSizes,
  titleBasicTags,
  titleBasicTextAlign
} from '@adv-mt/mt-title-basic'

import {DECORATIVE_IMAGE_ALT, SIZES} from './config.js'

const EmptyCaseDefault = ({
  buttonHref,
  buttonLeftIcon,
  buttonRightIcon,
  buttonText,
  imageSize = SIZES.SMALL,
  imageUrl,
  isPortrait = false,
  onClick,
  text,
  textNode,
  title,
  titleSize = titleBasicSizes.xss
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS = config.get('urlStatics')
  const isMobile = config.get('isMobile')

  const initialMediaQueryMatch = {
    defaultMatches: !isMobile
  }
  const isHigherThanMobile = useMediaQuery(useMediaQueryBreakpoints.sm, initialMediaQueryMatch)

  const IMAGE_URL = `${URL_STATICS}${imageUrl}`
  const IS_LINK = !!buttonHref
  const HAS_BUTTON_ACTION = !!buttonHref || !!onClick

  const imageClass = cx('mt-EmptyCaseDefault-image', `mt-EmptyCaseDefault-image--${imageSize}`, {
    'mt-EmptyCaseDefault-image--portrait': isPortrait
  })
  const textClass = cx('mt-EmptyCaseDefault-text', {
    'mt-EmptyCaseDefault-text--margin-xss': titleSize === titleBasicSizes.xss
  })

  const descriptionText = textNode ? undefined : i18n.t(text)

  return (
    <div className="mt-EmptyCaseDefault">
      {imageUrl ? (
        <div className={imageClass}>
          <AtomImage src={IMAGE_URL} alt={DECORATIVE_IMAGE_ALT} />
        </div>
      ) : null}
      <div className="mt-EmptyCaseDefault-content">
        <div className={textClass}>
          <TitleBasic
            as={titleBasicTags.h3}
            color={titleBasicColors.currentColor}
            description={descriptionText}
            descriptionTextAlign={titleBasicTextAlign.center}
            size={titleSize}
            textAlign={titleBasicTextAlign.center}
            title={i18n.t(title)}
          />
          {textNode ? <p className="mt-EmptyCaseDefault-textNode">{textNode}</p> : null}
        </div>
        {buttonText && HAS_BUTTON_ACTION && (
          <div>
            <AtomButton
              design={atomButtonDesigns.SOLID}
              href={buttonHref}
              leftIcon={buttonLeftIcon}
              link={IS_LINK}
              onClick={onClick}
              rightIcon={buttonRightIcon}
              shape={atomButtonShapes.CIRCULAR}
              size={isHigherThanMobile ? atomButtonSizes.MEDIUM : atomButtonSizes.LARGE}
            >
              {i18n.t(buttonText)}
            </AtomButton>
          </div>
        )}
      </div>
    </div>
  )
}

EmptyCaseDefault.displayName = 'EmptyCaseDefault'

EmptyCaseDefault.propTypes = {
  buttonHref: PropTypes.string,
  buttonLeftIcon: PropTypes.node,
  buttonRightIcon: PropTypes.node,
  buttonText: PropTypes.string,
  imageSize: PropTypes.oneOf(Object.values(SIZES)),
  imageUrl: PropTypes.string,
  isPortrait: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string,
  textNode: PropTypes.node,
  title: PropTypes.string,
  titleSize: PropTypes.oneOf(Object.values(titleBasicSizes))
}

export {SIZES as emptyCaseDefaultSizes, titleBasicSizes as emptyCaseDefaultTitleSizes}

export default EmptyCaseDefault
